import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, InputSignal, Signal } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ProductResume } from '../../../product/product.types';
import { SignalsStoreService } from '../../signals-store.service';
import { MarketStatus } from '../../types/common.types';

@Component({
  selector: 'app-product-card-v2-resume-mobile',
  imports: [
    NgbModule,
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule
  ],
  templateUrl: './product-card-v2-resume-mobile.component.html',
  styleUrl: './product-card-v2-resume-mobile.component.scss'
})
export class ProductCardV2ResumeMobileComponent {
  //#region Injection:
  #signalsStoreService = inject(SignalsStoreService);
  //#endregion

  //#region Input:
  product: InputSignal<ProductResume> = input.required();
  isFromWelcome: InputSignal<boolean> = input.required();
  //#endregion

  //#region Computed:
  hasSession: Signal<boolean> = computed(() => this.#signalsStoreService.hasSession());
  marketStatus: Signal<MarketStatus> = computed(() => this.#signalsStoreService.marketStatus());
  //#region 
}
